import type { Mutation, MutationCreateMyOrderArgs } from '@ab-core/graphql/dist';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { getErrorLoggerFunction } from '../utils';
import { CREATE_MY_ORDER } from './gql/createMyOrder';

type MutationDataType = Pick<Mutation, 'createMyOrder'>;
type ResponseDataType = MutationDataType | undefined;

const onError = getErrorLoggerFunction('createMyOrder');

const refetchQueries = ['GetCoupons', 'GetCustomerDataWithoutRightsAndActiveAccount'];

export const useCreateMyOrder = (variables: MutationCreateMyOrderArgs) => {
    const [response, setResponse] = useState<ResponseDataType>(undefined);

    const [createMyOrder, { loading, error, data, client }] = useMutation<MutationDataType, MutationCreateMyOrderArgs>(
        CREATE_MY_ORDER,
        {
            variables,
            refetchQueries,
            onError,
            update(cache) {
                cache.modify({
                    id: cache.identify({ __typename: 'Cart', id: variables.cartId }),
                    fields: {
                        cart(_existingCommentRefs, { DELETE }) {
                            return DELETE;
                        }
                    }
                });
            }
        }
    );

    useEffect(() => {
        if (data) {
            setResponse(data);
        }
    }, [data]);

    return {
        success: !!data,
        error: !!error,
        createMyOrder,
        loading,
        response,
        client
    };
};
